import { RoutalPalette, RoutalTab, RoutalTabs } from '@nx-smartmonkey/ui';
import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Grid } from '@mui/material';
import { DriversIcon } from '../../../../assets/svg/Plan/MenuBar/DriversIcon';
import { EditIcon } from '../../../../assets/svg/Plan/MenuBar/EditIcon';
import { OverviewIcon } from '../../../../assets/svg/Plan/MenuBar/OverviewIcon';
import { StopsIcon } from '../../../../assets/svg/Plan/MenuBar/StopsIcon';
import * as routing from '../../../../constants/Routing';
import { PlanFlat } from '../../../../domain/plan/PlanFlat';
import { Project } from '../../../../domain/project/Project';
import { intl } from '../../../../helpers/IntGlobalProvider';
import eventsPanel from '../../../../services/events';

interface PlanTabsProps {
  activePlan?: PlanFlat;
  activeProject?: Project;
}

export const PlanTabs = ({ activePlan, activeProject }: PlanTabsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState<string>(`overview`);

  useEffect(() => {
    if (location.pathname) {
      if (location.pathname.includes(`overview`)) {
        setValue(`overview`);
      }
      if (location.pathname.includes(`drivers`)) {
        setValue(`drivers`);
      }
      if (location.pathname.includes(`stops`)) {
        setValue(`stops`);
      }
      if (location.pathname.includes(`edit`)) {
        setValue(`edit`);
      }
    }
  }, [location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    if (activeProject && activePlan) {
      switch (newValue) {
        case `overview`:
          navigate(
            routing.PLANNER.PLAN_DETAILS.OVERVIEW.replace(`:projectId`, activeProject.id).replace(
              `:planId`,
              activePlan.id
            )
          );
          eventsPanel.planMenu(`overview`);
          break;
        case `drivers`:
          navigate(
            routing.PLANNER.PLAN_DETAILS.DRIVERS.replace(`:projectId`, activeProject.id).replace(
              `:planId`,
              activePlan.id
            )
          );
          eventsPanel.planMenu(`drivers`);
          break;
        case `stops`:
          navigate(
            routing.PLANNER.PLAN_DETAILS.STOPS.replace(`:projectId`, activeProject.id).replace(`:planId`, activePlan.id)
          );
          eventsPanel.planMenu(`stops`);
          break;
        case `edit`:
          navigate(
            routing.PLANNER.PLAN_DETAILS.EDIT.replace(`:projectId`, activeProject.id).replace(`:planId`, activePlan.id)
          );
          eventsPanel.planMenu(`edit`);
          break;
      }
    }
  };

  return (
    <Grid style={{ borderRight: `1px solid ${RoutalPalette.grey5}`, width: `100%`, height: `100%` }}>
      <RoutalTabs value={value} onChange={handleChange} aria-label="styled tabs">
        <RoutalTab
          icon={
            <OverviewIcon
              filled={value === `overview`}
              color={value === `overview` ? RoutalPalette.primary40 : RoutalPalette.neutral60}
              hoverColor={RoutalPalette.primary20}
              style={{ height: `20px`, width: `20px` }}
            />
          }
          label={intl.formatMessage({ id: `planner.plan_details.header.menu.overview` })}
          value="overview"
        />
        <RoutalTab
          icon={
            <DriversIcon
              filled={value === `drivers`}
              color={value === `drivers` ? RoutalPalette.primary40 : RoutalPalette.neutral60}
              hoverColor={RoutalPalette.primary20}
              style={{ height: `21px`, width: `21px` }}
            />
          }
          label={intl.formatMessage({ id: `planner.plan_details.header.menu.drivers` })}
          value="drivers"
        />
        <RoutalTab
          icon={
            <StopsIcon
              filled={value === `stops`}
              color={value === `stops` ? RoutalPalette.primary40 : RoutalPalette.neutral60}
              hoverColor={RoutalPalette.primary20}
              style={{ height: `21px`, width: `21px` }}
            />
          }
          label={intl.formatMessage({ id: `planner.plan_details.header.menu.stops` })}
          value="stops"
        />
        <RoutalTab
          icon={
            <EditIcon
              filled={value === `edit`}
              color={value === `edit` ? RoutalPalette.primary40 : RoutalPalette.neutral60}
              hoverColor={RoutalPalette.primary20}
              style={{ height: `19px`, width: `19px` }}
            />
          }
          label={intl.formatMessage({ id: `planner.plan_details.header.menu.edit` })}
          value="edit"
        />
      </RoutalTabs>
    </Grid>
  );
};
